import React from "react";
import { AMENITIES } from "../../data/site";
import * as LucideIcons from "lucide-react";

// Custom paddle (ping pong) icon — lucide has no paddle icon
const Paddle = ({ size = 22, className = "", strokeWidth = 2.5 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* paddle head */}
    <ellipse cx="10" cy="9" rx="6.5" ry="7" />
    {/* ball */}
    <circle cx="17.5" cy="6" r="1.6" fill="currentColor" />
    {/* handle */}
    <path d="M14.3 13.7 L20 19.5" />
    <path d="M13.1 15 L18.7 20.8" />
  </svg>
);

export default function Amenities() {
  return (
    <section id="amenities" data-testid="amenities-section" className="relative py-20 sm:py-28 px-4 sm:px-6 lg:px-10 bg-[#F3F7FA]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block bg-brand-green text-white font-fredoka font-bold rounded-full px-4 py-1.5 border-4 border-slate-900 neo-shadow-sm rotate-[2deg]">
            EVERYTHING INCLUDED
          </span>
          <h2 className="font-fredoka font-bold text-4xl sm:text-5xl lg:text-6xl mt-6 text-slate-900">
            Stocked. Stuffed. <span className="text-brand-blue">Ready to play.</span>
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-slate-700">
            We thought of everything so you can just show up and have fun.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {AMENITIES.map((a, idx) => {
            const Icon = a.icon === "Paddle" ? Paddle : (LucideIcons[a.icon] || LucideIcons.Sparkles);
            return (
              <div
                key={a.title}
                data-testid={`amenity-${idx}`}
                className="bg-white border-4 border-slate-900 rounded-3xl p-5 neo-shadow neo-press flex flex-col gap-3"
              >
                <div
                  className="w-12 h-12 rounded-2xl border-4 border-slate-900 grid place-items-center"
                  style={{ background: a.color }}
                >
                  <Icon size={22} className="text-white" strokeWidth={2.5} />
                </div>
                <p className="font-fredoka font-bold text-base sm:text-lg text-slate-900 leading-tight">
                  {a.title}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
